(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle)) return;
  if (window.__smoofLogoInvertV225) return;
  window.__smoofLogoInvertV225 = true;

  const PROPERTY_NAMES = {
    logo: 'properties[_SMOOF Logo invertiert]',
    'logo-copy': 'properties[_SMOOF Logo 1 Duplikat invertiert]',
    'logo-2': 'properties[_SMOOF Logo 2 invertiert]'
  };
  const state = { logo: false, 'logo-copy': false, 'logo-2': false };
  let hydrated = false;
  let renderPending = false;

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]')) || null;
  }

  function propertyInput(name) {
    return Array.from((productForm() || document).querySelectorAll('input'))
      .find(input => input.name === name) || null;
  }

  function readBoolean(name) {
    return /^(1|true|ja|yes)$/i.test(String(propertyInput(name)?.value || ''));
  }

  function setProperty(name, value) {
    const form = productForm();
    if (!form) return;
    let input = propertyInput(name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.smoofLogoInvertProperty = 'true';
      form.appendChild(input);
    }
    input.value = value ? 'Ja' : 'Nein';
  }

  function hydrate() {
    if (hydrated || !productForm()) return;
    state.logo = readBoolean(PROPERTY_NAMES.logo);
    state['logo-copy'] = readBoolean(PROPERTY_NAMES['logo-copy']);
    state['logo-2'] = readBoolean(PROPERTY_NAMES['logo-2']);
    hydrated = true;
  }

  function logoImages(id) {
    const selector = id === 'logo-2'
      ? '[data-smoof-logo-instance="2"] img'
      : id === 'logo-copy'
        ? '[data-smoof-logo-instance="copy"] img'
        : '[data-smoof-logo-editor-frame]:not([data-smoof-logo-instance]) img';
    return Array.from(document.querySelectorAll(selector));
  }

  function render() {
    hydrate();
    ['logo', 'logo-copy', 'logo-2'].forEach(id => {
      logoImages(id).forEach(image => {
        image.style.filter = state[id] ? 'invert(1)' : '';
        image.dataset.smoofLogoInverted = String(state[id]);
      });
      setProperty(PROPERTY_NAMES[id], state[id]);
    });
  }

  function scheduleRender() {
    if (renderPending) return;
    renderPending = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      renderPending = false;
      render();
    }));
  }

  function set(id, value, announce = true) {
    if (!(id in state)) return false;
    hydrate();
    state[id] = Boolean(value);
    render();
    window.SmoofDesignRenderer?.scheduleRender?.();
    if (announce) {
      window.dispatchEvent(new CustomEvent('smoof:logo-invert-changed', {
        detail: { id, inverted: state[id] }
      }));
    }
    return state[id];
  }

  window.SmoofLogoInvertTools = Object.freeze({
    get(id) {
      hydrate();
      return Boolean(state[id]);
    },
    set,
    toggle(id) {
      return set(id, !this.get(id));
    },
    getHistoryState() {
      hydrate();
      return { ...state };
    },
    applyHistoryState(next) {
      if (!next) return false;
      set('logo', Boolean(next.logo), false);
      set('logo-copy', Boolean(next['logo-copy']), false);
      set('logo-2', Boolean(next['logo-2']), false);
      window.dispatchEvent(new CustomEvent('smoof:logo-invert-changed', {
        detail: { ...state }
      }));
      return true;
    }
  });

  ['smoof:logo-file-changed', 'smoof:logo-2-file-changed'].forEach(eventName => {
    window.addEventListener(eventName, scheduleRender);
  });
  ['smoof:editor-reset-all', 'smoof:editor-reset-content'].forEach(eventName => {
    window.addEventListener(eventName, () => {
      state.logo = false;
      state['logo-copy'] = false;
      state['logo-2'] = false;
      render();
      window.dispatchEvent(new CustomEvent('smoof:logo-invert-changed', {
        detail: { ...state }
      }));
    });
  });

  new MutationObserver(scheduleRender).observe(document.body, {
    childList: true,
    subtree: true
  });
  document.addEventListener('change', scheduleRender, true);
  scheduleRender();
})();
